import { render, staticRenderFns } from "./ComboboxPacotes.vue?vue&type=template&id=1be505d6"
import script from "./ComboboxPacotes.vue?vue&type=script&lang=js"
export * from "./ComboboxPacotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports